<template>
    <div>
        <el-tabs v-model="query.type" @tab-click="handleSearch">
            <el-tab-pane label="连接器" name="1"></el-tab-pane>
            <el-tab-pane label="工具" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="分类名称" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('cpgl_cpfl_tjyjfl')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增一级分类 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="" align="center" width="50" />
                <el-table-column label="排序" align="center" prop="sort" />
                <el-table-column label="分类名称" align="center" prop="name" />
                <el-table-column label="商品数量" align="center" prop="goods_num" />
                <el-table-column label="是否显示" align="center">
                    <template slot-scope="{ row }">
                        {{ row.status == 1 ? "是" : "否" }}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="{ row }">
                        <el-button v-if="row.fid == '0' && permission('cpgl_cpfl_tjxjfl')" size="mini" type="text" @click="handleAddSon(row)">
                            添加下级分类
                        </el-button>
                        <el-button v-if="permission('cpgl_cpfl_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button v-if="permission('cpgl_cpfl_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <FormVue ref="form" @update="search"></FormVue>
    </div>
</template>

<script>
import { list, del } from "@/api/product/category";
import listMixin from "@/mixins/list";
import FormVue from "./form.vue";

export default {
    components: { FormVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                type: "1",
                search_keyword: "",
            },
            module: "分类",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$refs.form.open({ parent: true, type: this.query.type });
        },
        handleAddSon(row) {
            this.$refs.form.open({ parent: false, type: this.query.type, parent_cuuid: row.cuuid });
        },
        handleEdit(row) {
            this.$refs.form.open({ parent: row.fid == "0" ? true : false, type: this.query.type, cuuid: row.cuuid, uuid: row.uuid });
        },
    },
};
</script>
